module.exports = __webpack_public_path__ + "img/bottomImg.06acc965.jpg";